export enum WorkerRole {
  qlnld_cap_nhat = 'QLNLD_CAP_NHAT',
  qlnld_chi_tiet = 'QLNLD_CHI_TIET',
  qlnld_them = 'QLNLD_THEM',
  qlnld_xem_danh_sach = 'QLNLD_XEM_DANH_SACH',
}
